var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 526,
    viewBox: "0 0 296 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 212.491H139.947L167.5 234.124L75 322.629L-17.5 234.124L40.559 214.457L75 212.491Z",
    fill: "url(#paint0_linear_782_152)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0006 322.624L19.8936 255.757H130.107L75.0006 322.624Z",
    fill: "url(#paint1_linear_782_152)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.106 255.755L167.5 234.122L75 145.617L-17.5 234.122L19.894 255.755H130.106Z",
    fill: "url(#paint2_linear_782_152)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0005 145.625L130.107 255.759H19.8945L75.0005 145.625Z",
    fill: "url(#paint3_linear_782_152)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_782_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-80.9368 190.837C-80.9368 190.837 -115.247 316.009 0.902176 388.988C99.1252 450.706 198.326 323.95 124.481 259.305C73.8852 215.015 72.5662 181.874 69.3532 138.661C64.2562 70.1132 -40.7648 38.3149 -80.9368 190.837Z",
    fill: "url(#paint4_radial_782_152)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_782_152",
    x: -185.669,
    y: -18.3301,
    width: 435.825,
    height: 523.809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_782_152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_782_152",
    x1: 126.171,
    y1: 212.491,
    x2: 126.171,
    y2: 352.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA17DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_782_152",
    x1: 75.0006,
    y1: 352.124,
    x2: 75.0006,
    y2: 255.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA17DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_782_152",
    x1: 23.091,
    y1: 293.122,
    x2: 23.091,
    y2: 116.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_782_152",
    x1: 74.1595,
    y1: 116.125,
    x2: 74.1595,
    y2: 255.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_782_152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.4522 153.57) rotate(92.6593) scale(223.544 199.613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#750FF7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDiamond);
export default __webpack_public_path__ + "static/media/img-diamond.859f590f9d3a3dc95049281d7e76f4fb.svg";
export { ForwardRef as ReactComponent };